import Wrapper from '@app/Wrapper.js'

Munio.UserCourses = class UserCourses extends Wrapper {
  constructor(selector, courseId = null) {
    super(selector, { courseId })
  }

  get replace() {
    return true
  }

  component() {
    return import('./App.vue')
  }
}
